// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2AuAE","errors":"Errors_errors__30Ya2"};